import { createSelector } from "reselect";
import getShowVerticallySplitControls from "selectors/breakpoint/getShowVerticallySplitControls";
import { BreakpointDefinition } from "utils/Breakpoint";
import getBreakpoint from "./getBreakpoint";

export default createSelector(
  [getBreakpoint, getShowVerticallySplitControls],
  (breakpoint, showVerticallySplitControls) =>
    !showVerticallySplitControls &&
    breakpoint.isGreaterThan(BreakpointDefinition.XS),
);
